export default __webpack_public_path__ + "static/media/iris.68860484.svg";